import { useState } from 'react';

export type UseCommittedTextDraftOptions = {
  committedValue: string | null | undefined;
  onCommit: (trimmedValue: string) => void;
};

/**
 * Local draft state for a text field bound to a committed form value (e.g.
 * Series payee/name) — not bound straight to the form's setters, so an
 * emptied field just reverts to the last committed value on blur instead of
 * clearing it. Shared between the Bill Setup Series details pane and the
 * Create/Edit Series dialog's Basic Details tab, which use the identical
 * pattern for their Name/Payee field.
 */
export function useCommittedTextDraft({ committedValue, onCommit }: UseCommittedTextDraftOptions): {
  draft: string;
  setDraft: (value: string) => void;
  commit: () => void;
} {
  const [draft, setDraft] = useState(committedValue ?? '');

  const commit = () => {
    const trimmed = draft.trim();
    if (trimmed && trimmed !== committedValue) {
      onCommit(trimmed);
    }
    setDraft(trimmed || committedValue || '');
  };

  return { draft, setDraft, commit };
}
